import React, { createContext, useContext, useState } from 'react';

interface AlertContextProps {
  successMessage: string | null;
  errorMessage: string | null;
  setSuccessMessage: (message: string | null) => void;
  setErrorMessage: (message: string | null) => void;
}

export const AlertContext = createContext<AlertContextProps | undefined>(
  undefined,
);

export const AlertProvider: any = ({ children }: any) => {
  const [successMessage, setSuccessMessage] = useState<string | null>(null);
  const [errorMessage, setErrorMessage] = useState<string | null>(null);

  return (
    <AlertContext.Provider
      value={{
        successMessage,
        errorMessage,
        setSuccessMessage,
        setErrorMessage,
      }}
    >
      {children}
    </AlertContext.Provider>
  );
};

export const useAlert = () => {
  const context = useContext(AlertContext);
  if (!context) {
    throw new Error('useAlert must be used within an AlertProvider');
  }
  return context;
};
